import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import {useTheme} from "@mui/material/styles";
import {CloseIcon, DeleteIcon, Logo, LogoIcon, NewProjectIcon, RenameIcon} from "./HomeIcons";
import React, {useContext, useEffect, useRef, useState} from "react";
import {AuthContext} from "../../context/AuthContext";
import {
    AdaptRecordingMode,
    formatToReadableLargeTitle,
    GridVideoLayout,
    IMAGE_UPLOAD, LibrettoProjectTypes,
    LibrettoStudioNameStyle,
    LibrettoStudioTheme,
    LibrettoWorkflowTypes,
    RefreshTokenAndRetry
} from "../../utils/utils";
import {collection, doc, getDoc, onSnapshot, query, updateDoc, where} from "firebase/firestore";
import {db} from "../../Firebase";
import {
    AssetDeleted, AssetProjectId, AssetType,
    AssetUserId,
    kAssetsCollectionName, kLibrettoUserCollectionName,
    kProjectsCollectionName, kRoomStateCollectionName, LibrettoUserId,
    ProjectDeleted,
    ProjectUserId, RoomName, RoomUserId
} from "../../utils/CollectionConstants";
import {
    CameraIcon,
    ChangeViewButton, EditButton, MobileLogoutButton, NewProjectButton, PlanRecordingButton,
    RecordingStudioButton,
    ShareButton,
    SortButton,
    ThreeDotsButton,
    UploadButton, V2RecordButton, ViewAllProjectsButton
} from "./HomeButtons";
import {Card, ClickAwayListener, DialogContent, Typography} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import {CLIENT_URL, FetchContext} from "../../context/FetchContext";
import NewEditableTitle, {ReadOnlyTitle} from "./NewEditableTitle";
import {
    GridProjects,
    ListProjects, ListViewProject,
    ListViewRecording,
    NewGridRecordings,
    RecordingsListView
} from "../NewHome/NewAssetAndProjectCards";
import {useConfirmDialog} from "./DeleteConfirmation";
import TextField from "@mui/material/TextField";
import {Link, useNavigate, useParams} from "react-router-dom";
import UploadContentCard from "./UploadContentCard";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import NewShareProjectCard from "./NewShareProjectCard";
import mixpanel from "mixpanel-browser";
import {CropPortrait, CropPortraitOutlined, Laptop, TodayOutlined, VideoCall} from "@mui/icons-material";
import Tooltip from "@mui/material/Tooltip";
import SignInUserIntercomComponent, {UnauthenticatedUserIntercomComponent} from "../../components/IntercomComponent";
import {HiLightningBolt} from "react-icons/hi";
import {
    HomeSidebarButton,
    NewSidebarThumbnailCard,
    RedesignedSidebarThumbnailCard,
    SidebarProjectThumbnail
} from "./ProjectThumbnail";
import {InviteIcon} from "../NewStudio/SettingsIcon";
import CreateSession from "./CreateSession";
import {NewInviteParticipantCard} from "../NewStudio/NewInviteParticipantCard";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import SelectableCard from "./SelectableCard";
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import HeadphonesOutlinedIcon from '@mui/icons-material/HeadphonesOutlined';
import FeedOutlinedIcon from '@mui/icons-material/FeedOutlined';
import ClosedCaptionOffOutlinedIcon from '@mui/icons-material/ClosedCaptionOffOutlined';
import AutoFixHighOutlinedIcon from '@mui/icons-material/AutoFixHighOutlined';
import SidebarNavButton, {SidebarSubdirButton} from "./SidebarNavButton";
import ContentCutOutlinedIcon from '@mui/icons-material/ContentCutOutlined';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import {RecordSomethingMenu} from "./ProjectContextMenu";
import AgenticUploadContentCard from "./AgenticUploadContentCard";
import TranslateIcon from '@mui/icons-material/Translate';
import LibrettoV2PopupCard from "./LibrettoV2Popup";

const kLibrettoCurrentProjectId = 'librettoCurrentProjectId';
const kLibrettoSortNewest = 'librettoSortNewest';
const kLibrettoGridView = 'librettoGridView';

const urlFriendlyUserFriendlyRoomName = ({userFriendlyRoomName}) => {
    return userFriendlyRoomName.replace(/ /g, '-');
}

const guestURL = (roomName, userFriendlyRoomName) => {
    return CLIENT_URL + "/guest/" + roomName + "/" + urlFriendlyUserFriendlyRoomName({userFriendlyRoomName});
}

const NewProjectCard = ({newProjectTitle, setNewProjectTitle, onKeyDown, onClose, onClick}) => {

    const boxStyle = {
        display: "flex",
        flexDirection: "column",
        width: "486px",
        padding: "24px 24px 40px 24px",
        alignItems: "center",
        gap: "32px",
        borderRadius: "12px",
    }

    const headerStyle = {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
        alignSelf: "stretch",
    }

    const headerTextStyle = {
        fontFamily: "Inter",
        fontSize: "18px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "24px",
        letterSpacing: "0.18px",
    }

    const textBoxStyle = {
        display: "flex",
        width: "100%",
    }

    const confirmButtonStyle = {
        display: "flex",
        height: "52px",
        padding: "10px 60px",
        justifyContent: "center",
        alignItems: "center",
        gap: "10px",
        background: "#2B6BFD",
        borderRadius: "6px",
        cursor: "pointer",
        // Hover effect
        '&:hover': {
            background: "linear-gradient(0deg, rgba(0, 0, 0, 0.10)0%, rgba(0, 0, 0, 0.10)100%), #2B6BFD",
        },
    }

    const buttonTextStyle = {
        fontFamily: "Inter",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "20px",
        letterSpacing: "0.14px",
        color: "#FFFFFF",
    }

    return (
        <Box style={boxStyle}>
            <Box style={headerStyle}>
                <Box style={headerTextStyle}>
                    Set the title of your new project
                </Box>
                <Box style={{display: "flex", marginLeft: "auto", cursor: "pointer"}} onClick={onClose}>
                    <CloseIcon/>
                </Box>
            </Box>
            <Box style={textBoxStyle}>
                <TextField
                    variant="outlined"
                    name="title"
                    fullWidth
                    onKeyDown={onKeyDown}
                    value={newProjectTitle}
                    onChange={(e) => setNewProjectTitle(e.target.value)}
                    margin="normal"
                    InputProps={{
                        style: {
                            fontFamily: "Inter",
                            fontSize: "14px",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "20px",
                            letterSpacing: "0.14px",
                            color: "#000000",
                            height: "64px",
                            backgroundColor: "white",
                        },
                    }}
                    InputLabelProps={{
                        style: {
                            color: '#9E9E9E',
                            fontFamily: 'Inter',
                            fontSize: '12px',
                            fontWeight: 400,
                        },
                        shrink: true,
                    }}
                    sx={{
                        width: '100%',
                        height: '64px',
                        marginTop: "10px",
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                border: "1px solid #e8e8e8",
                            },
                            '&:hover fieldset': {
                                border: "1px solid #e8e8e8",
                            },
                            '&.Mui-focused fieldset': {
                                border: "1px solid #e8e8e8",
                            },
                        },
                        '& .MuiInputBase-root': {
                            backgroundColor: 'white',
                        },
                    }}
                />
            </Box>
            <Box sx={confirmButtonStyle} onClick={onClick}>
                <Box style={buttonTextStyle}>Confirm</Box>
            </Box>
        </Box>
    )
}

export const RecordingTypesContextMenu = ({
                                              setRecordingTypesMenuOpen,
                                              handleScreenRecordingClick,
                                              handleStudioClick
                                          }) => {

    const boxStyle = {
        position: "absolute",
        top: "70px",
        right: "390px",
        display: "inline-flex",
        padding: "16px",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: "4px",
        borderRadius: "12px",
        background: "#FFFFFF",
        boxShadow: "0px 30px 80px 0px rgba(0, 0, 0, 0.15)",
        zIndex: 1000,
    }

    const itemStyle = {
        display: "flex",
        padding: "16px",
        alignItems: "center",
        gap: "8px",
        alignSelf: "stretch",
        cursor: "pointer",
        borderRadius: "8px",
        // On hover
        '&:hover': {
            background: "#F3F4F5",
        },
    }

    const itemTextStyle = {
        fontFamily: "Inter",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "20px",
        letterSpacing: "0.14px",
    }

    const itemTextSubtitileStyle = {
        fontFamily: "Inter",
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "16px",
    }

    return (
        <ClickAwayListener onClickAway={() => setRecordingTypesMenuOpen(false)}>
            <Card style={boxStyle}>
                <Box sx={itemStyle} onClick={handleScreenRecordingClick}>
                    <Box style={{display: "flex", height: "20px", width: "20px", marginBottom: "2px"}}>
                        <Laptop/>
                    </Box>
                    <Box style={itemTextStyle}>
                        Screen Recording
                    </Box>
                </Box>
                <Box sx={itemStyle} onClick={handleStudioClick}>
                    <Box style={{display: "flex", height: "20px", width: "20px", marginBottom: "2px"}}>
                        <VideoCall/>
                    </Box>
                    <Box style={itemTextStyle}>
                        Go to Studio
                    </Box>
                </Box>
            </Card>
        </ClickAwayListener>
    )
}

export const ScheduleRecordingContextMenu = ({
                                                 setScheduleRecordingMenuOpen,
                                                 handleInviteClick,
                                                 handleScheduleClick,
                                                 userId,
                                             }) => {

    const onInviteClick = () => {
        mixpanel.track('Invited_From_Home', {
            'userId': userId,
        });
        handleInviteClick();
    }

    const onScheduleClick = () => {
        mixpanel.track('Scheduling', {
            'userId': userId,
        });
        handleScheduleClick();
    }

    const boxStyle = {
        position: "absolute",
        top: "70px",
        right: "390px",
        display: "inline-flex",
        padding: "16px",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: "4px",
        borderRadius: "12px",
        background: "#FFFFFF",
        boxShadow: "0px 30px 80px 0px rgba(0, 0, 0, 0.15)",
        zIndex: 1000,
    }

    const itemStyle = {
        display: "flex",
        padding: "16px",
        alignItems: "center",
        gap: "8px",
        alignSelf: "stretch",
        cursor: "pointer",
        borderRadius: "8px",
        // On hover
        '&:hover': {
            background: "#F3F4F5",
        },
    }

    const itemTextStyle = {
        fontFamily: "Inter",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "20px",
        letterSpacing: "0.14px",
    }

    const itemTextSubtitileStyle = {
        fontFamily: "Inter",
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "16px",
    }

    const disabledItemStyle = {
        display: "flex",
        padding: "16px",
        alignItems: "center",
        gap: "8px",
        alignSelf: "stretch",
        cursor: "not-allowed",
        borderRadius: "8px",
    }

    return (
        <ClickAwayListener onClickAway={() => setScheduleRecordingMenuOpen(false)}>
            <Card style={boxStyle}>
                <Box sx={itemStyle} onClick={onScheduleClick}>
                    <Box style={{display: "flex", height: "20px", width: "20px", marginBottom: "2px"}}>
                        <TodayOutlined/>
                    </Box>
                    <Box style={itemTextStyle}>
                        Schedule session
                    </Box>
                </Box>
                <Box sx={itemStyle} onClick={onInviteClick}>
                    <Box style={{display: "flex", height: "20px", width: "20px", marginBottom: "2px"}}>
                        <InviteIcon color={"#1a1a1a"}/>
                    </Box>
                    <Box style={itemTextStyle}>
                        Invite to record
                    </Box>
                </Box>
            </Card>
        </ClickAwayListener>
    )
}

export const ProjectContextMenu = ({
                                       setThreeDotsMenuOpen,
                                       top,
                                       right,
                                       handleRenameClick,
                                       handleDeleteClick,
                                       isAsset
                                   }) => {

    const boxStyle = {
        position: "absolute",
        top: "70px",
        right: isAsset ? "260px" : "150px",
        display: "inline-flex",
        padding: "16px",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: "4px",
        borderRadius: "12px",
        background: "#FFFFFF",
        // boxShadow: "0px 30px 80px 0px rgba(0, 0, 0, 0.15)",
        zIndex: 1000,
    }

    const itemStyle = {
        display: "flex",
        padding: "16px",
        alignItems: "center",
        gap: "8px",
        alignSelf: "stretch",
        cursor: "pointer",
        borderRadius: "8px",
        // On hover
        '&:hover': {
            background: "#F3F4F5",
        },
    }

    const itemTextStyle = {
        fontFamily: "Inter",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "20px",
        letterSpacing: "0.14px",
    }

    const deleteHandler = async () => {
        await handleDeleteClick();
    }

    return (
        <ClickAwayListener onClickAway={() => setThreeDotsMenuOpen(false)}>
            <Card style={boxStyle}>
                <Box sx={itemStyle} onClick={handleRenameClick}>
                    <Box style={{display: "flex", height: "20px", width: "20px"}}>
                        <RenameIcon/>
                    </Box>
                    <Box style={itemTextStyle}>
                        {isAsset ? "Rename Recording" : "Rename Project"}
                    </Box>
                </Box>
                <Box sx={itemStyle} onClick={deleteHandler}>
                    <Box style={{display: "flex", height: "20px", width: "20px"}}>
                        <DeleteIcon/>
                    </Box>
                    <Box style={itemTextStyle}>
                        {isAsset ? "Delete Recording" : "Delete Project"}
                    </Box>
                </Box>
            </Card>
        </ClickAwayListener>
    )
}

const ProfileAvatarMenu = ({
                               setProfileAvatarMenuOpen,
                               profileMenuLeft,
                               profileMenuRight,
                               handleLogoutClick,
                               handleSettingsClick
                           }) => {

    const boxStyle = {
        position: "absolute",
        bottom: "100px",
        left: profileMenuLeft,
        display: "inline-flex",
        padding: "16px",
        minWidth: profileMenuRight - profileMenuLeft,
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: "4px",
        borderRadius: "12px",
        background: "#FFFFFF",
        boxShadow: "0px 30px 80px 0px rgba(0, 0, 0, 0.15)",
        zIndex: 1000,
    }

    const itemStyle = {
        display: "flex",
        padding: "16px",
        alignItems: "center",
        gap: "8px",
        alignSelf: "stretch",
        cursor: "pointer",
        borderRadius: "8px",
        // On hover
        '&:hover': {
            background: "#F3F4F5",
        },
    }

    const itemTextStyle = {
        fontFamily: "Inter",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "20px",
        letterSpacing: "0.14px",
    }

    return (
        <ClickAwayListener onClickAway={() => setProfileAvatarMenuOpen(false)}>
            <Card style={boxStyle}>
                <Box sx={itemStyle} onClick={handleSettingsClick}>
                    <Box style={{marginTop: "8px"}}>
                        <SettingsIcon/>
                    </Box>
                    <Box style={itemTextStyle}>
                        Settings
                    </Box>
                </Box>
                <Box sx={itemStyle} onClick={handleLogoutClick}>
                    <Box style={{marginTop: "8px"}}>
                        <LogoutIcon/>
                    </Box>
                    <Box style={itemTextStyle}>
                        Logout
                    </Box>
                </Box>
            </Card>
        </ClickAwayListener>
    )
}

const RecordingsView = ({assets, setSwitchToComputerFormOpen, showAsGrids, isSharedView, token, isMobile}) => {

    if (showAsGrids && !isMobile) {
        return (
            <Grid container spacing={2} marginTop={1}>
                <NewGridRecordings recordings={assets} setSwitchToComputerFormOpen={setSwitchToComputerFormOpen}
                                   isSharedView={isSharedView} token={token}/>
            </Grid>
        )
    }


    return (
        <Grid item marginTop={2}>
            <RecordingsListView recordings={assets} setSwitchToComputerFormOpen={setSwitchToComputerFormOpen}
                                isSharedView={isSharedView} token={token} isMobile={isMobile}/>
        </Grid>
    );
};

const ProjectsView = ({
                          projects,
                          setSwitchToComputerFormOpen,
                          showAsGrids,
                          isSharedView,
                          isMobile,
                          deleteProject,
                          handleProjectCardClick
                      }) => {
    if (showAsGrids && !isMobile) {
        return (
            <Grid container spacing={2} marginTop={1}>
                <GridProjects projects={projects} setSwitchToComputerFormOpen={setSwitchToComputerFormOpen}
                              deleteProject={deleteProject} handleProjectCardClick={handleProjectCardClick}/>
            </Grid>
        )
    }

    return (
        <>
            {projects.map((project, i) => (
                <ListViewProject project={project} onClick={handleProjectCardClick} isMobile={isMobile}/>
            ))}
        </>
    )
}

const mainAreaStyle = (isMobile) => {
    return {
        flex: 1,
        height: "100%",
        // Padding right "32px", top "20px", bottom "20px", left "60px"
        padding: isMobile ? "10px 10px 10px 10px" : "20px 32px 20px 60px",
        overflowY: "auto",
        overflowX: "hidden",
    }
}

const headerButtonsStyle = (isMobile) => {
    return {
        display: isMobile ? "none" : "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        gap: "8px",
    }
}

const topAreaStyle = (isMobile) => {
    return {
        display: isMobile ? "none" : "flex",
        flexDirection: "row",
        justifyContent: "space-between",
    }
}

const headerAndButtonsStyle = {
    display: "flex",
    flexDirection: "row",
    marginTop: "40px",
    justifyContent: "space-between",
    marginBottom: "16px",
}

const recordingTextStyle = {
    fontFamily: "Inter",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "24px",
}

const pageStyle = {
    height: "100vh",
    width: "100vw",
    backgroundColor: "#f3f4f5",
    display: "flex",
    flexDirection: "row",
}

const logoBoxStyle = {
    display: "flex",
    padding: "20px 12px",
    alignItems: "center",
    gap: "2px",
    alignSelf: "stretch",
    marginBottom: "24px",
    cursor: "pointer",
}


const effectiveRecordingsStyle = (showAsGrid) => {

}

const SingleProjectView = ({
                               currentProjectId,
                               sortedAssets,
                               isEditingTitle,
                               setIsEditingTitle,
                               handleThreeDotsButtonClick,
                               threeDotsMenuOpen,
                               threeDotsMenuRight,
                               threeDotsMenuTop,
                               handleRenameProjectClick,
                               handleDeleteProjectClick,
                               setThreeDotsMenuOpen,
                               switchToComputerFormOpen,
                               setSwitchToComputerFormOpen,
                               showAsGrids,
                               isMobile,
                               sortNewest,
                               isRestrictedPlan,
                               ConfirmDialogComponent,
                               handleGridViewButtonClick,
                               handleSortButtonClick,
                               handleShareButtonClick,
                               showShareProjectCard,
                               setShowShareProjectCard,
                               currentProjectTitle,
                               setCurrentProjectTitle,
                               fetchContext,
                               authContext
                           }) => {

    // Refresh project urls
    useEffect(() => {
        if (currentProjectId === null) return;

        const LoadProjectUrls = async () => {
            try {
                await fetchContext.authAxios.get(`/project/${currentProjectId}`, {
                    headers: {
                        Authorization: `Bearer ${authContext.getToken()}`,
                    }
                });
            } catch (error) {
                console.error("Error getting track urls:", error);
            }
        }

        LoadProjectUrls();
        return () => {
        };
    }, [currentProjectId]);


    return (
        <>
            <Box style={topAreaStyle(isMobile)}>
                {currentProjectId ? <NewEditableTitle projectId={currentProjectId} isEditing={isEditingTitle}
                                                      setIsEditingTitle={setIsEditingTitle} title={currentProjectTitle}
                                                      setTitle={setCurrentProjectTitle}/> :
                    <Typography>Loading...</Typography>}
                <Box style={{flexDirection: "row", gap: "12px", display: "flex"}}>
                    <Box>
                        <ThreeDotsButton onClick={handleThreeDotsButtonClick}/>
                    </Box>
                    {threeDotsMenuOpen &&
                        <ProjectContextMenu setThreeDotsMenuOpen={setThreeDotsMenuOpen} top={threeDotsMenuTop}
                                            right={threeDotsMenuRight} handleRenameClick={handleRenameProjectClick}
                                            handleDeleteClick={() => handleDeleteProjectClick(currentProjectId)}
                                            isAsset={false}/>}
                    <ConfirmDialogComponent/>
                    <Dialog
                        open={switchToComputerFormOpen}
                        onClose={() => setSwitchToComputerFormOpen(false)}
                        aria-labelledby="form-dialog-title"
                    >
                        <DialogContent sx={{
                            borderRadius: '30px',
                            display: 'flex',        // Enable flexbox
                            justifyContent: 'center', // Center horizontally
                            alignItems: 'center',     // Center vertically
                            minWidth: {xs: '300px', md: '400px'},
                        }}>
                            <Typography><b>Please switch to your computer.</b> For now, you can only do this on a
                                larger screen.</Typography>
                        </DialogContent>
                    </Dialog>
                    <Box>
                        <ShareButton onClick={handleShareButtonClick} disabled={isRestrictedPlan}/>
                    </Box>
                    {showShareProjectCard && <NewShareProjectCard entityId={currentProjectId}
                                                                  onClose={() => setShowShareProjectCard(false)}
                                                                  isAsset={false}/>}
                </Box>
            </Box>
            <Box style={headerAndButtonsStyle}>
                <Box style={recordingTextStyle}>
                    Project assets
                </Box>
                <Box style={headerButtonsStyle(isMobile)}>
                    <Box>
                        <SortButton onClick={handleSortButtonClick} sortNewest={sortNewest} iconOnly={false}/>
                    </Box>
                    <Box>
                        <ChangeViewButton isGridView={showAsGrids} onClick={handleGridViewButtonClick}/>
                    </Box>
                </Box>
            </Box>
            <Box style={effectiveRecordingsStyle(showAsGrids)} key={sortNewest}>
                <RecordingsView assets={sortedAssets} showAsGrids={showAsGrids}
                                setSwitchToComputerFormOpen={setSwitchToComputerFormOpen} isMobile={isMobile}/>
            </Box>
        </>
    )
}


const AgenticHome = () => {

    const theme = useTheme();

    const navigate = useNavigate();

    const [projects, setProjects] = useState([]);
    const [currentProjectId, setCurrentProjectId] = useState(null);
    const [currentProjectAssets, setCurrentProjectAssets] = useState([]);
    const [sortedAssets, setSortedAssets] = useState([]);
    const [sortedProjects, setSortedProjects] = useState([]);
    const [sortNewest, setSortNewest] = useState(() => {
        const stored = sessionStorage.getItem(kLibrettoSortNewest);
        return stored !== null ? stored === 'true' : true;
    });
    const [showAsGrids, setShowAsGrids] = useState(() => {
        const stored = sessionStorage.getItem(kLibrettoGridView);
        return stored !== null ? stored === 'true' : false;
    });
    const [selectedTrackData, setSelectedTrackData] = useState(null);
    const [selectedAssetData, setSelectedAssetData] = useState(null);

    const [isHomeView, setIsHomeView] = useState(true);

    const ViewState = {
        HOME: 'HOME',
        PROJECTS: 'PROJECTS',
        SINGLE_PROJECT: 'SINGLE_PROJECT',
        CREATE_SESSION: 'CREATE_SESSION',
    };

    const [currentView, setCurrentView] = useState(ViewState.HOME);


    const [currentProjectTitle, setCurrentProjectTitle] = useState("");

    // console.log("Current project id:", currentProjectId);

    const authContext = useContext(AuthContext);
    const fetchContext = useContext(FetchContext);

    const hasUpgradeIntent = authContext.hasUpgradeIntent();

    useEffect(() => {
        if (hasUpgradeIntent) {
            authContext.clearUpgradeIntent();
            navigate("/settings?upgrade=true");
        }
    }, [hasUpgradeIntent]);

    const userPlan = authContext.getUserPlan();

    const isRestrictedPlan = userPlan === "0" || userPlan === 0 || userPlan === undefined || userPlan === null;

    mixpanel.identify(authContext.getUserId());

    mixpanel.people.set({
        '$name': authContext.getUserDisplayName(),
        '$email': authContext.getUserEmail(),
        'plan': authContext.getUserPlan(),
    });

    const [threeDotsMenuOpen, setThreeDotsMenuOpen] = useState(false);
    const [threeDotsMenuRight, setThreeDotsMenuRight] = useState(0);
    const [threeDotsMenuTop, setThreeDotsMenuTop] = useState(0);

    const [isEditingTitle, setIsEditingTitle] = useState(false);
    const [titleCreationCardOpen, setTitleCreationCardOpen] = useState(false);
    const [titleCreationProjectId, setTitleCreationProjectId] = useState(null);

    const [recordingTypesMenuOpen, setRecordingTypesMenuOpen] = useState(false);
    const [scheduleRecordingMenuOpen, setScheduleRecordingMenuOpen] = useState(false);
    const [showScheduleForm, setShowScheduleForm] = useState(false);
    const [showInviteForm, setShowInviteForm] = useState(false);

    const [invitedEmails, setInvitedEmails] = useState([]);
    const [roomName, setRoomName] = useState('');
    const [userFriendlyRoomName, setUserFriendlyRoomName] = useState('');

    const [switchToComputerFormOpen, setSwitchToComputerFormOpen] = useState(false);

    const [profileAvatarMenuOpen, setProfileAvatarMenuOpen] = useState(false);
    const [profileMenuLeft, setProfileMenuLeft] = useState(0);

    const [profileMenuRight, setProfileMenuRight] = useState(0);

    const [newProjectTitle, setNewProjectTitle] = useState('My Project');

    const [showUploadCard, setShowUploadCard] = useState(false);

    const [uploadCardWorkflowType, setUploadCardWorkflowType] = useState(null);

    const [showShareProjectCard, setShowShareProjectCard] = useState(false);

    const [editButtonLoading, setEditButtonLoading] = useState(false);

    const [recordSomethingMenuPosition, setRecordSomethingMenuPosition] = useState({});

    const recordSomethingButtonRef = useRef(null);

    const [recordSomethingMenuOpen, setRecordSomethingMenuOpen] = useState(false);

    const auth = useContext(AuthContext);

    const userId = authContext.getUserId();

    const [hasSeenLibrettoV2Popup, setHasSeenLibrettoV2Popup] = useState(null); // null = loading
    const [showLibrettoV2Popup, setShowLibrettoV2Popup] = useState(false);

    useEffect(() => {
        const fetchUserData = async () => {
            if (!userId) return;

            try {
                const entityRef = doc(db, kLibrettoUserCollectionName, userId);
                const docSnap = await getDoc(entityRef);
                if (docSnap.exists()) {
                    const seen = docSnap.data().hasSeenAppSumoPopup;
                    setHasSeenLibrettoV2Popup(seen ?? false); // default to false if undefined
                    if (!seen) {
                        setShowLibrettoV2Popup(true);
                    }
                } else {
                    console.log("No such user doc");
                }
            } catch (error) {
                console.error("Error fetching user data: ", error);
            }
        };

        fetchUserData();
    }, [userId]);

    const handleSortButtonClick = () => {
        const newSortNewest = !sortNewest;
        setSortNewest(newSortNewest);
        sessionStorage.setItem(kLibrettoSortNewest, newSortNewest.toString());
    };

    const handleGridViewButtonClick = () => {
        const newShowAsGrids = !showAsGrids;
        setShowAsGrids(newShowAsGrids);
        sessionStorage.setItem(kLibrettoGridView, newShowAsGrids.toString());
    }

    // useEffect(() => {
    //     if (projects.length > 0 && !projects.some(project => project.projectId === currentProjectId)) {
    //         const newCurrentProjectId = projects[0].projectId;
    //         setCurrentProjectId(newCurrentProjectId);
    //         sessionStorage.setItem(kLibrettoCurrentProjectId, newCurrentProjectId);
    //     }
    // }, [projects, currentProjectId]);

    // Sort projects by date based on sortNewest
    useEffect(() => {
        const sorted = [...projects].sort((a, b) => {
            return sortNewest ? b.lastViewed - a.lastViewed : a.lastViewed - b.lastViewed;
        });
        setSortedProjects(sorted);
    }, [sortNewest, projects]);

    // Reset currentProjectId if it no longer exists in projects list
    useEffect(() => {
        if (currentProjectId && !projects.some(p => p.projectId === currentProjectId)) {
            setCurrentProjectId(null);
            sessionStorage.removeItem(kLibrettoCurrentProjectId);
        }
    }, [projects, currentProjectId]);

    // Sort the current project assets by date based on sortNewest
    useEffect(() => {
        const sorted = [...currentProjectAssets].sort((a, b) => {
            return sortNewest ? b.createTime - a.createTime : a.createTime - b.createTime;
        });
        setSortedAssets(sorted);
    }, [sortNewest, currentProjectAssets]);

    const pageStyle = {
        height: "100vh",
        width: "100vw",
        backgroundColor: "#f3f4f5",
        display: "flex",
        flexDirection: "row",
    }

    const isXl = useMediaQuery(theme.breakpoints.up('xl'));
    const isLg = useMediaQuery(theme.breakpoints.up('lg'));

    const sidebarWidth = isXl ? "280px" : isLg ? "250px" : "250px";

    const sideBarStyle = (isMobile) => {
        return {
            width: sidebarWidth,
            height: "100vh",
            backgroundColor: "#fff",
            display: isMobile ? "none" : "flex",
            flexDirection: "column",
            padding: "8px 12px 24px 12px",
            alignItems: "flex-start",
        }
    }

    const createProject = async (projectName) => {
        try {
            const {data} = await fetchContext.authAxios.post('/project', {
                projectName: projectName,
            }, {
                headers: {
                    Authorization: `Bearer ${authContext.getToken()}`,
                }
            });
            setTitleCreationProjectId(data.projectId);
            setTitleCreationCardOpen(true);
        } catch (err) {
            if (err.response.status === 401) {
                await RefreshTokenAndRetry(err, authContext, fetchContext);
            }
            console.log("Error is ", err)
        }
    }

    const sidebarHeaderStyle = {
        display: "flex",
        padding: "0px 12px",
        justifyContent: "space-between",
        alignItems: "center",
        alignSelf: "stretch",
        flexDirection: "row",
    }

    const sidebarHeaderTextStyle = {
        fontFamily: "Inter",
        fontSize: "18px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "24px",
        letterSpacing: "0.18px",
    }

    const newProjectIconStyle = (disabled) => {
        return ({
                display: "flex",
                padding: "12px",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
                borderRadius: "100px",
                backgroundColor: "#EFF4FE",
                cursor: disabled ? "not-allowed" : "pointer",
                // ON hover
                '&:hover': {
                    backgroundColor: disabled ? "#EFF4FE" : "rgba(43, 107, 253, 0.20)",
                },
            }
        )
    }

    const dividerStyle = {
        display: "flex",
        padding: "1px 0px",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "10px",
        alignSelf: "stretch",
        marginTop: "16px",
        marginBottom: "16px",
    }

    const projectTitleStyle = {
        display: 'flex',
        padding: '16px 12px',
        alignItems: 'center',
        gap: '12px',
        alignSelf: 'stretch',
        borderRadius: '8px',
        cursor: 'pointer',
        // ON hover
        '&:hover': {
            background: "rgba(43, 107, 253, 0.10)",
        },
    }

    const selectedProjectStyle = {
        ...projectTitleStyle,
        background: "#EFF4FE",
    }

    const actualDividerStyle = {
        height: "1px",
        alignSelf: "stretch",
        backgroundColor: "#E8E8E8",
    }

    const effectiveStyle = (index) => {
        if (projects[index].projectId === currentProjectId) {
            return selectedProjectStyle;
        } else {
            return projectTitleStyle;
        }
    }

    const projectTitleTextStyle = {
        color: "#1A1A1A",
        fontFamily: "Inter",
        fontSize: "15px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "20px",
        letterSpacing: "0.16px",
    }

    const selectedProjectTitleTextStyle = {
        ...projectTitleTextStyle,
        color: "#2B6BFD",
    }

    const effectiveTextStyle = (index) => {
        if (projects[index].projectId === currentProjectId) {
            return selectedProjectTitleTextStyle;
        } else {
            return projectTitleTextStyle;
        }
    }

    const profileBoxStyle = {
        display: 'flex',
        // Set width to be 15px less than sidebarWidth
        width: `calc(${sidebarWidth} - 15px)`,
        padding: '12px',
        alignItems: 'center',
        gap: '6px',
        alignSelf: 'stretch',
        borderRadius: '8px',
        justifyContent: "flex-start",
        flexDirection: "row",
        // marginTop: "auto",
        border: "1px solid #bbbbbb",
        cursor: "pointer",
        // ON hover
        '&:hover': {
            border: "1px solid #999999",
            //background: "linear-gradient(0deg, rgba(0, 0, 0, 0.10)0%, rgba(0, 0, 0, 0.10)100%), #E3E5E8",
        },
        // Focused state
        '&:focus': {
            border: "1px solid #999999",
            //background: "linear-gradient(0deg, rgba(255, 255, 255, 0.10)0%, rgba(255, 255, 255, 0.10)100%), #E3E5E8",
        }
    }

    const upgradeBoxStyle = {
        display: 'flex',
        width: `calc(${sidebarWidth} - 15px)`,
        padding: '16px',
        alignItems: 'center',
        gap: '12px',
        alignSelf: 'stretch',
        borderRadius: '12px',
        justifyContent: 'flex-start',
        flexDirection: 'row',
        border: '1px solid transparent',
        background: 'linear-gradient(90deg, #2B6BFD, #2F80ED)',
        boxShadow: '0px 4px 8px rgba(43, 107, 253, 0.3)',
        cursor: 'pointer',
        transition: 'transform 0.2s, box-shadow 0.2s',
        '&:hover': {
            transform: 'scale(1.03)',
            boxShadow: '0px 6px 12px rgba(43, 107, 253, 0.5)',
        },
        '&:focus': {
            outline: 'none',
            boxShadow: '0px 0px 0px 3px rgba(43, 107, 253, 0.4)',
        },
    };

    const upgradeInfoStyle = {
        flexShrink: 1,
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        color: '#FFFFFF',
    };

    const upgradeTextStyle = {
        fontFamily: 'Inter',
        fontSize: '16px',
        fontWeight: 600,
        lineHeight: '22px',
        color: '#FFFFFF',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        width: '100%',
    };

    const subtextStyle = {
        fontFamily: 'Inter',
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '16px',
        color: '#D9E2EF',
    };

    const lightningIconStyle = {
        fontSize: '24px',
        color: '#FFF',
        filter: 'drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.25))',
    };


    const GetInitial = (name) => {
        return name ? name.charAt(0).toUpperCase() : '?';
    }

    const profileImagePictureStyle = {
        width: "40px",
        height: "40px",
        borderRadius: '50%',
        objectFit: 'cover',
        display: 'block',
        border: '2px solid #fff',
        flexShrink: 0,
    };

    const profileImgStyle = {
        width: "40px",
        height: "40px",
        borderRadius: '50%',
        border: '2px solid #fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#2b6bfd',
        color: '#fff',
        fontWeight: 600,
        fontSize: 16,     // looks balanced at 40px circle
        lineHeight: 1,
        textTransform: 'uppercase',
        flexShrink: 0,
    };

    const resolvedProfileImage = authContext.getUserPhotoUrl();

    const titleAndDateAreaStyle = {
        display: "flex",
        gap: "12px",
        flexDirection: "column",
    }

    const topTitleTextStyle = {
        fontFamily: "Inter",
        fontSize: "42px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "52px",
    }

    const recordingsGridStyle = {}

    const userInfoStyle = {
        flexShrink: 1,
        minWidth: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        cursor: "pointer",
    }

    const usernameTextStyle = {
        fontFamily: "Inter",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "20px",
        letterSpacing: "0.14px",
        color: "#1A1A1A",
        // Show ellipsis if the name is too long
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        width: "100%",
    }

    const settingsTextStyle = {
        color: "#606060",
        fontFamily: "Inter",
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "16px",
        letterSpacing: "0.48px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        width: "100%",
    }

    const deleteProject = async ({projectId}) => {
        try {
            await fetchContext.authAxios.delete(`/project/${projectId}`, {
                headers: {
                    Authorization: `Bearer ${authContext.getToken()}`,
                }
            });
            console.log("Project deleted successfully:", projectId);
        } catch (error) {
            console.error("Error deleting project:", error);
            throw error;
        }
    };

    const {openDialog, ConfirmDialogComponent} = useConfirmDialog({confirmText: 'Delete', cancelText: 'Cancel'});

    const handleDeleteProjectClick = (projectId) => {
        console.log("Delete called with project id: ", projectId);
        openDialog({
            title: 'Delete Project',
            message: 'This project and all its assets will be permanently deleted.',
            onConfirm: async () => {
                await deleteProject({projectId});
            },
        });
    };

    useEffect(() => {
        if (!userId) {
            return;
        }

        const q = query(collection(db, kProjectsCollectionName), where(ProjectUserId, "==", userId), where(ProjectDeleted, "==", false));
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
                const newProjects = [];
                querySnapshot.forEach((doc) => {
                    newProjects.push(doc.data());
                });
                if (newProjects.length > 0) {
                    setProjects(newProjects);
                } else {
                    // Handle case when all projects are deleted
                    setProjects([]);
                }
            },
            (error) => {
                if (error.code === 'permission-denied') {
                    authContext.logout();
                }
            });

        return () => unsubscribe();
    }, [authContext, userId]);

    // Load the assets that belong to the current project.
    useEffect(() => {
        if (currentProjectId) {
            const q = query(collection(db, kAssetsCollectionName), where(AssetUserId, "==", userId), where(AssetDeleted, "==", false), where(AssetProjectId, "==", currentProjectId));
            const unsubscribe = onSnapshot(q, (querySnapshot) => {
                    const newAssets = [];
                    querySnapshot.forEach((doc) => {
                        // EXCLUDED_ASSETS
                        if (doc.data()[AssetType] !== "SOUNDBOARD_AUDIO" && doc.data()[AssetType] !== "BRAND_LOGO" && doc.data()[AssetType] !== "IMAGE_UPLOAD") {
                            newAssets.push(doc.data());
                        }
                    });
                    setCurrentProjectAssets(newAssets);
                },
                (error) => {
                    if (error.code === 'permission-denied') {
                        authContext.logout();
                    }
                });

            return () => unsubscribe();
        } else {
            setCurrentProjectAssets([]);
        }
    }, [currentProjectId]);

// Refreshes urls for assets and tracks of the project
    useEffect(() => {
        if (currentProjectId === null) {
            return;
        }

        const LoadProjectUrls = async () => {
            try {
                await fetchContext.authAxios.get(`/project/${currentProjectId}`, {
                    headers: {
                        Authorization: `Bearer ${authContext.getToken()}`,
                    }
                });
            } catch (error) {
                console.error("Error getting track urls:", error);
            }
        }

        LoadProjectUrls();
        return () => {
        };
    }, [currentProjectId]);

    const handleCardClick = (item) => {
        sessionStorage.setItem(kLibrettoCurrentProjectId, item.projectId);
        setCurrentProjectId(item.projectId);
    }


    const handleThreeDotsButtonClick = (event) => {

        if (isMobile) {
            event.preventDefault();
            setSwitchToComputerFormOpen(true);
            return;
        }

        if (threeDotsMenuOpen) {
            setThreeDotsMenuOpen(false);
            return;
        }

        // Get the top and right position of the button
        const top = event.currentTarget.getBoundingClientRect().top;
        const right = event.currentTarget.getBoundingClientRect().right;
        // Set the position of the context menu
        setThreeDotsMenuTop(top);
        setThreeDotsMenuRight(right);
        setThreeDotsMenuOpen(true);
    }

    const handleRecordingTypesButtonClick = (event) => {
        if (isMobile) {
            event.preventDefault();
            setSwitchToComputerFormOpen(true);
            return;
        }

        if (recordingTypesMenuOpen) {
            setRecordingTypesMenuOpen(false);
            return;
        }

        setRecordingTypesMenuOpen(true);
    }

    const handleRenameProjectClick = (e) => {
        if (isMobile) {
            e.preventDefault();
            setSwitchToComputerFormOpen(true);
            return;
        }

        e.stopPropagation();
        setIsEditingTitle(true);
        setThreeDotsMenuOpen(false);
    }

    const updateTitle = async ({projectId, title}) => {
        // Update Firestore
        const entityRef = doc(db, kProjectsCollectionName, projectId);
        try {
            await updateDoc(entityRef, {name: title});
            console.log('Title updated successfully');
        } catch (error) {
            console.error('Error updating title: ', error);
        }
    };

    const handleUpdateTitleClick = async () => {
        await updateTitle({projectId: titleCreationProjectId, title: newProjectTitle});
        setTitleCreationCardOpen(false);
        setNewProjectTitle('Untitled Project');
        sessionStorage.setItem(kLibrettoCurrentProjectId, titleCreationProjectId);
        setCurrentProjectId(titleCreationProjectId);
        setTitleCreationProjectId(null);
    }

    const handleKeyDownForTitle = async (e) => {
        if (e.key === 'Enter') {
            await handleUpdateTitleClick();
        }
    }

    const handleCloseNewProjectCard = () => {
        setTitleCreationCardOpen(false);
        setNewProjectTitle('Untitled Project');
    }

    const navigateToSettings = () => {
        navigate('/settings');
    }

    const upArrowStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: 'auto',
        color: '#888',
        flexShrink: 0,
    };

    const handleProfileButtonClick = (e) => {
        e.stopPropagation();
        setProfileMenuLeft(e.currentTarget.getBoundingClientRect().left);
        setProfileMenuRight(e.currentTarget.getBoundingClientRect().right);
        setProfileAvatarMenuOpen(!profileAvatarMenuOpen);
    }

    const logoutUser = async () => {
        await authContext.logout()
    }

    const handleShareButtonClick = (e) => {
        if (isMobile) {
            e.preventDefault();
            setSwitchToComputerFormOpen(true);
            return;
        }

        // e is a click on a button. Get the right position of the button
        setShowShareProjectCard(!showShareProjectCard);
    }

    const getFirstName = (name) => {
        if (name) {
            return name.split(' ')[0];
        }
        return '';
    }

    const isMobile = useMediaQuery(theme.breakpoints.down('smd'));

    const handleRecordWithOthersClick = (e) => {
        navigate(`/studio`);
    }

    const handleRecordAudioOnlyClick = (e) => {
        navigate(`/record/audio`);
    }


    const handleRecordScreenClick = (e) => {
        navigate(`/record/screen`);
    }

    const handleRecordCameraClick = (e) => {
        navigate(`/record/camera`);
    }

    const CreateEditForProject = async ({projectId}) => {
        try {
            const {data} = await fetchContext.authAxios.post(`/editor/project/${projectId}`, {}, {
                headers: {
                    Authorization: `Bearer ${auth.getToken()}`,
                },
            });
            return data.editId;
        } catch (error) {
            if (error.response.status === 401) {
                await RefreshTokenAndRetry(error, auth, fetchContext);
            }
        }
    }

    const CreateEditAndNavigateToEditor = () => {
        setEditButtonLoading(true);
        CreateEditForProject({projectId: currentProjectId}).then((editId) => {
            navigate(`/edit/${editId}`);
            window.location.reload();
            setEditButtonLoading(false);
        }).catch((error) => console.error("Error creating edit: ", error));
    }

    const newProjectDisabled = isRestrictedPlan && projects.length >= 2;

    const navigateToUpgrade = () => {
        mixpanel.track('Upgrade attempt', {
            'userId': authContext.getUserId(),
            'email': authContext.getUserEmail(),
        });
        navigate("/settings?upgrade=true")
    }

    const handleCreateProjectClick = async () => {
        if (newProjectDisabled) {
            return;
        }
        await createProject("Untitled project")
    }

    useEffect(() => {
        if (userId !== '') {
            const q = query(collection(db, kRoomStateCollectionName), where(RoomUserId, "==", userId));
            const unsubscribe = onSnapshot(q, (querySnapshot) => {
                const newRoomState = [];
                querySnapshot.forEach((doc) => {
                    newRoomState.push(doc.data());
                });
                if (newRoomState.length > 0) {
                    setInvitedEmails(newRoomState[0].hasOwnProperty("invitedEmails") ? newRoomState[0].invitedEmails : []);
                    setRoomName(newRoomState[0].hasOwnProperty("roomName") ? newRoomState[0].roomName : "");
                }
            });
            return () => unsubscribe();
        } else {
        }
    }, [userId]);

    useEffect(() => {
        if (!userId) {
            return;
        }

        const q = query(collection(db, kLibrettoUserCollectionName), where(LibrettoUserId, "==", userId));
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const newUserState = [];
            querySnapshot.forEach((doc) => {
                newUserState.push(doc.data());
            });
            if (newUserState.length > 0) {
                setUserFriendlyRoomName(newUserState[0].hasOwnProperty("userFriendlyRoomName") ? newUserState[0].userFriendlyRoomName : "");
            }
        });
        return () => unsubscribe();
    }, [userId]);

    const headerTextStyle = {
        fontSize: '36px',
        fontWeight: 400,
        padding: '0px', // Reduced padding to compensate for border
        margin: '0',
        height: '52px', // Match line-height
        lineHeight: '52px',
        backgroundColor: 'transparent',
        width: '100%',
        maxWidth: '100%',
        border: '1px solid transparent', // Always have a border, but transparent when not editing
        boxSizing: 'border-box', // Include border in element's dimensions
        fontFamily: "Inter",
        textOverflow: "ellipsis",
        fontStyle: "normal",
        transition: 'border-color 0.3s', // Smooth transition for border color
    };

    const miniHeaderTextStyle = {
        fontSize: '30px',
        fontWeight: 400,
        padding: '0px', // Reduced padding to compensate for border
        margin: '0',
        height: '52px', // Match line-height
        lineHeight: '52px',
        backgroundColor: 'transparent',
        width: '100%',
        maxWidth: '100%',
        border: '1px solid transparent', // Always have a border, but transparent when not editing
        boxSizing: 'border-box', // Include border in element's dimensions
        fontFamily: "Inter",
        textOverflow: "ellipsis",
        fontStyle: "normal",
        transition: 'border-color 0.3s', //
    }

    const handleHomeSidebarButtonClick = () => {
        setCurrentView(ViewState.HOME);
        setCurrentProjectId(null);
    }

    const handleProjectsSidebarButtonClick = () => {
        setCurrentView(ViewState.PROJECTS);
        setCurrentProjectId(null);
    }

    const handleProjectCardClick = (project) => {
        if (project.projectType === LibrettoProjectTypes.ProjectTypeEditor || project.projectType === LibrettoProjectTypes.ProjectTypeCaptions) {

            console.log("Navigating to /agent/ ", project.projectId);
            navigate(`/agent/${project.projectId}`);
            return;
        }

        console.log("Project type is: ", project.projectType);

        setCurrentView(ViewState.SINGLE_PROJECT);
        setCurrentProjectId(project.projectId);
    }

    const handleViewAllProjectsButtonClick = () => {
        setCurrentView(ViewState.PROJECTS);
        setCurrentProjectId(null);
    }

    const handleRecordSomethingButtonClick = () => {
        if (recordSomethingButtonRef.current && recordSomethingMenuOpen === false) {
            const rect = recordSomethingButtonRef.current.getBoundingClientRect();
            setRecordSomethingMenuPosition({
                top: rect.bottom + window.scrollY + 4, // below the button
                left: rect.left + window.scrollX
            });
            setRecordSomethingMenuOpen(true);
            return;
        }
        setRecordSomethingMenuOpen(false);
    }

    const handleEditAudioVideoSelect = () => {
        setUploadCardWorkflowType(LibrettoWorkflowTypes.EDIT_AUDIO_VIDEO);
        setShowUploadCard(true);
    }

    const handleMakePodcastSelect = () => {
        setUploadCardWorkflowType(LibrettoWorkflowTypes.MAKE_PODCAST);
        setShowUploadCard(true);
    }

    const handleTranscribeFileSelect = () => {
        setUploadCardWorkflowType(LibrettoWorkflowTypes.TRANSCRIBE_FILE);
        setShowUploadCard(true);
    }

    const handleAddCaptionsSelect = () => {
        setUploadCardWorkflowType(LibrettoWorkflowTypes.ADD_CAPTIONS);
        setShowUploadCard(true);
    }

    const handleCleanUpAudioSelect = () => {
        setUploadCardWorkflowType(LibrettoWorkflowTypes.CLEAN_UP_AUDIO);
        setShowUploadCard(true);
    }

    const handleScheduleRecordingSelect = () => {
        setUploadCardWorkflowType(LibrettoWorkflowTypes.SCHEDULE_RECORDING);
        setShowUploadCard(true);
    }

    const handleCreateSocialClipsSelect = () => {
        setUploadCardWorkflowType(LibrettoWorkflowTypes.CREATE_SOCIAL_CLIPS);
        setShowUploadCard(true);
    }

    const handleTranslateAndDubSelect = () => {
        setUploadCardWorkflowType(LibrettoWorkflowTypes.TRANSLATE_AND_DUB);
        setShowUploadCard(true);
    }

    const ProjectsViewAtHome = () => {
        return (
            <>
                <Box style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    display: "flex",
                    alignItems: "center"
                }}>
                    <Box style={headerTextStyle}>
                        Projects
                    </Box>
                    <Box style={{
                        flexdirection: "row",
                        justifyContent: "space-between",
                        gap: "10px",
                        display: "flex",
                        alignItems: "center"
                    }}>
                        <Box>
                            <NewProjectButton onClick={handleCreateProjectClick}
                                              newProjectDisabled={true}/>
                        </Box>
                        <Dialog
                            open={titleCreationCardOpen}
                            onClose={handleCloseNewProjectCard}
                            aria-labelledby="form-dialog-title"
                        >
                            <NewProjectCard setNewProjectTitle={setNewProjectTitle} newProjectTitle={newProjectTitle}
                                            onKeyDown={handleKeyDownForTitle} onClose={handleCloseNewProjectCard}
                                            onClick={handleUpdateTitleClick}/>
                        </Dialog>
                    </Box>
                </Box>

                <Box style={headerAndButtonsStyle}>
                    <Box style={headerButtonsStyle(isMobile)}>
                        <Box>
                            <SortButton onClick={handleSortButtonClick} sortNewest={sortNewest} iconOnly={false}/>
                        </Box>
                        <Box>
                            <ChangeViewButton isGridView={showAsGrids} onClick={handleGridViewButtonClick}/>
                        </Box>
                    </Box>
                </Box>
                <Box style={effectiveRecordingsStyle(showAsGrids)} key={sortNewest}>
                    <ProjectsView projects={sortedProjects} showAsGrids={showAsGrids}
                                  deleteProject={handleDeleteProjectClick}
                                  setSwitchToComputerFormOpen={setSwitchToComputerFormOpen} isMobile={isMobile}
                                  handleProjectCardClick={handleProjectCardClick}/>
                </Box>
            </>
        )
    }

    const HomeViewAtHome = () => {

        return (
            <>
                <Box style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    display: "flex",
                    alignItems: "center"
                }}>
                    <Box style={headerTextStyle}>
                        What do you want to do?
                    </Box>
                    <Box style={{
                        flexdirection: "row",
                        justifyContent: "space-between",
                        gap: "10px",
                        display: "flex",
                        alignItems: "center"
                    }}>
                        <Box>
                            <div ref={recordSomethingButtonRef}>
                                <V2RecordButton onClick={handleRecordSomethingButtonClick}/>
                            </div>
                        </Box>
                        <Box>
                            <NewProjectButton onClick={handleCreateProjectClick}
                                              newProjectDisabled={true}/>
                        </Box>
                        <Dialog
                            open={titleCreationCardOpen}
                            onClose={handleCloseNewProjectCard}
                            aria-labelledby="form-dialog-title"
                        >
                            <NewProjectCard setNewProjectTitle={setNewProjectTitle} newProjectTitle={newProjectTitle}
                                            onKeyDown={handleKeyDownForTitle} onClose={handleCloseNewProjectCard}
                                            onClick={handleUpdateTitleClick}/>
                        </Dialog>
                    </Box>
                </Box>

                <Box style={{display: "flex", flexDirection: "column"}}>

                    <Box style={headerAndButtonsStyle}>
                    </Box>
                    <Box style={effectiveRecordingsStyle(true)}>
                        <Dialog
                            open={showUploadCard}
                            onClose={() => setShowUploadCard(false)}
                            aria-labelledby="form-dialog-title"
                            maxWidth={"1000px"}
                        >
                            <DialogContent sx={{
                                borderRadius: '30px',
                                display: 'flex',        // Enable flexbox
                                justifyContent: 'center', // Center horizontally
                                alignItems: 'center',     // Center vertically
                                padding: "0px 0px 0px 0px",
                            }}>
                                <AgenticUploadContentCard onClose={() => setShowUploadCard(false)}
                                                          projectId={currentProjectId}
                                                          workflowType={uploadCardWorkflowType}/>
                            </DialogContent>
                        </Dialog>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={6} md={4} lg={4} xl={3} key={0}>
                                <SelectableCard icon={<ContentCutOutlinedIcon sx={{color: "#FF6B6B"}}/>}
                                                onClick={handleEditAudioVideoSelect} disabled={true}
                                                label={"Edit audio or video"}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4} xl={3} key={1}>
                                <SelectableCard icon={<VideocamOutlinedIcon sx={{color: "#4ECDC4"}}/>} disabled={true}
                                                onClick={handleMakePodcastSelect}
                                                label={"Make a podcast"}/>
                            </Grid>
                            {recordSomethingMenuOpen && <RecordSomethingMenu setOpen={setRecordSomethingMenuOpen}
                                                                             handleRecordScreenClick={handleRecordScreenClick}
                                                                             handleRecordCameraClick={handleRecordCameraClick}
                                                                             top={recordSomethingMenuPosition.top}
                                                                             handleRecordAudioOnlyClick={handleRecordAudioOnlyClick}
                                                                             left={recordSomethingMenuPosition.left}
                                                                             handleRecordWithOthersClick={handleRecordWithOthersClick}/>}
                            <Grid item xs={12} sm={6} md={4} lg={4} xl={3} key={1}>
                                <SelectableCard icon={<FeedOutlinedIcon sx={{color: "#45B7D1"}}/>} disabled={true}
                                                onClick={handleTranscribeFileSelect} label={"Transcribe a file"}/>
                            </Grid>
                            {/*<Grid item xs={12} sm={6} md={4} lg={4} xl={3} key={1}>*/}
                            {/*    <SelectableCard icon={<AutoFixHighOutlinedIcon sx={{color: "#F9CA24"}}/>} onClick={handleCleanUpAudioSelect} label={"Clean up audio"}/>*/}
                            {/*</Grid>*/}
                            <Grid item xs={12} sm={6} md={4} lg={4} xl={3} key={1}>
                                <SelectableCard icon={<ClosedCaptionOffOutlinedIcon sx={{color: "#6C5CE7"}}/>}
                                                onClick={handleAddCaptionsSelect} label={"Add captions"}
                                                disabled={true}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4} xl={3} key={1}>
                                <SelectableCard icon={<CropPortraitOutlined sx={{color: "#A8E6CF"}}/>}
                                                onClick={handleCreateSocialClipsSelect} label={"Create social clips"}
                                                disabled={true}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4} xl={3} key={1}>
                                <SelectableCard icon={<TodayOutlined sx={{color: "#FF8B94"}}/>}
                                                onClick={handleScheduleRecordingSelect} label={"Schedule a recording"} disabled={true}/>
                            </Grid>
                            {/*<Grid item xs={12} sm={6} md={4} lg={4} xl={3} key={1}>*/}
                            {/*    <SelectableCard icon={<TranslateIcon sx={{color: "#FFD93D"}}/>} onClick={handleTranslateAndDubSelect} label={"Translate & Dub video"}/>*/}
                            {/*</Grid>*/}
                        </Grid>


                    </Box>

                    <br/>
                    {sortedProjects.slice(0, 3) ?
                        <Box>
                            <Box style={miniHeaderTextStyle}>
                                Recent projects
                            </Box>
                            <Box style={effectiveRecordingsStyle(true)}>
                                <ProjectsView projects={sortedProjects.slice(0, 3)} showAsGrids={true}
                                              setSwitchToComputerFormOpen={setSwitchToComputerFormOpen}
                                              isMobile={isMobile} deleteProject={handleDeleteProjectClick}
                                              handleProjectCardClick={handleProjectCardClick}/>
                            </Box>
                        </Box> : null}
                    <br/>
                    <Box style={{display: "flex", flexDirection: "row", justifyContent: "center"}}>
                        <ViewAllProjectsButton onClick={handleViewAllProjectsButtonClick}/>
                    </Box>
                </Box>
            </>
        )
    }

    useEffect(() => {
        if (currentProjectId === null) {
            return;
        }

        const LoadProjectUrls = async () => {
            try {
                await fetchContext.authAxios.get(`/project/${currentProjectId}`, {
                    headers: {
                        Authorization: `Bearer ${authContext.getToken()}`,
                    }
                });
            } catch (error) {
                console.error("Error getting track urls:", error);
            }
        }

        LoadProjectUrls();
        return () => {
        };
    }, [currentProjectId]);

    const isLifetimePlanUser = userPlan === "6" || userPlan === "7";

    return (
        <Box style={pageStyle}>
            <SignInUserIntercomComponent user={authContext.getUser()}/>
            {hasSeenLibrettoV2Popup !== null && showLibrettoV2Popup && (
                <LibrettoV2PopupCard
                    onClose={() => setShowLibrettoV2Popup(false)}
                    userId={userId}
                    isLifetimePlanUser={isLifetimePlanUser}
                />
            )}
            <ConfirmDialogComponent/>
            <Box style={sideBarStyle(isMobile)}>
                <Box style={logoBoxStyle} onClick={() => navigate("/")}>
                    <LogoIcon/>
                </Box>
                <Box style={dividerStyle}>
                    <Box style={actualDividerStyle}/>
                </Box>
                <Box sx={{
                    flexGrow: 1,
                    maxHeight: "calc(100vh - 100px)",
                    overflowY: "auto",
                    alignItems: "center",
                    gap: "4px",
                }}>
                    <SidebarNavButton label={"Home"} onClick={handleHomeSidebarButtonClick}
                                      selected={currentView === ViewState.HOME}
                                      icon={<HomeOutlinedIcon sx={{color: "#2D2D2D"}}/>}/>
                    <Box sx={{marginTop: "8px"}}>
                        <SidebarNavButton label={"Projects"} onClick={handleProjectsSidebarButtonClick}
                                          selected={currentView === ViewState.PROJECTS}
                                          icon={<FolderOpenOutlinedIcon sx={{color: "#2D2D2D"}}/>}/>
                    </Box>
                    {currentView === ViewState.SINGLE_PROJECT && currentProjectId &&
                        <SidebarSubdirButton icon={<SubdirectoryArrowRightIcon/>} selected={true}
                                             label={currentProjectTitle} onClick={() => {
                        }}/>}
                </Box>
                <Box sx={{marginTop: "auto", flexDirection: "column", gap: "10px"}}>
                    {isRestrictedPlan && (
                        <Box sx={upgradeBoxStyle} onClick={navigateToUpgrade}>
                            <Box>
                                <HiLightningBolt style={lightningIconStyle}/>
                            </Box>
                            <Box sx={userInfoStyle}>
                                <Box sx={upgradeTextStyle}>Upgrade</Box>
                                <Box sx={upgradeInfoStyle}>Unlock core features</Box>
                            </Box>
                        </Box>
                    )}
                    <br/>
                    <Box sx={profileBoxStyle} onClick={handleProfileButtonClick}>
                        {resolvedProfileImage ? (
                            <Box component="img" src={resolvedProfileImage} alt="Profile"
                                 sx={profileImagePictureStyle}/>
                        ) : (
                            <Box sx={profileImgStyle}>
                                {GetInitial(authContext.getUserDisplayName())}
                            </Box>
                        )}
                        <Box sx={userInfoStyle}>
                            <Box sx={usernameTextStyle}>
                                {getFirstName(authContext.getUserDisplayName())}
                            </Box>
                            <Box sx={settingsTextStyle}>
                                {authContext.getUserEmail()}
                            </Box>
                        </Box>
                        <Box sx={upArrowStyle}>
                            <KeyboardArrowUpIcon/>
                        </Box>
                    </Box>
                </Box>
                {profileAvatarMenuOpen &&
                    <ProfileAvatarMenu profileMenuLeft={profileMenuLeft} profileMenuRight={profileMenuRight}
                                       setProfileAvatarMenuOpen={setProfileAvatarMenuOpen}
                                       handleLogoutClick={() => logoutUser()}
                                       handleSettingsClick={() => navigate("/settings")}/>}
            </Box>
            <Box style={mainAreaStyle(isMobile)}>
                {isMobile ?
                    <Box sx={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                        <Box style={logoBoxStyle} onClick={() => navigate("/")}>
                            <LogoIcon/>
                        </Box>
                        <Box style={logoBoxStyle}>
                            <MobileLogoutButton onClick={logoutUser}/>
                        </Box>
                    </Box> : null}

                {currentProjectId ? <SingleProjectView currentProjectId={currentProjectId} sortedAssets={sortedAssets}
                                                       showAsGrids={showAsGrids}
                                                       isEditingTitle={isEditingTitle}
                                                       setIsEditingTitle={setIsEditingTitle}
                                                       handleGridViewButtonClick={handleGridViewButtonClick}
                                                       handleRenameClick={handleRenameProjectClick}
                                                       handleDeleteProjectClick={handleDeleteProjectClick}
                                                       setSwitchToComputerFormOpen={setSwitchToComputerFormOpen}
                                                       handleThreeDotsButtonClick={handleThreeDotsButtonClick}
                                                       threeDotsMenuTop={threeDotsMenuTop}
                                                       threeDotsMenuRight={threeDotsMenuRight}
                                                       threeDotsMenuOpen={threeDotsMenuOpen}
                                                       ConfirmDialogComponent={ConfirmDialogComponent}
                                                       setThreeDotsMenuOpen={setThreeDotsMenuOpen}
                                                       isMobile={isMobile}
                                                       setShowShareProjectCard={setShowShareProjectCard}
                                                       showShareProjectCard={showShareProjectCard}
                                                       handleShareButtonClick={handleShareButtonClick}
                                                       handleSortButtonClick={handleSortButtonClick}
                                                       sortNewest={sortNewest}
                                                       handleRenameProjectClick={handleRenameProjectClick}
                                                       isRestrictedPlan={isRestrictedPlan}
                                                       setCurrentProjectTitle={setCurrentProjectTitle}
                                                       currentProjectTitle={currentProjectTitle}
                                                       switchToComputerFormOpen={switchToComputerFormOpen}
                                                       authContext={auth} fetchContext={fetchContext}/> :
                    currentView === ViewState.HOME ? <HomeViewAtHome/> :
                        currentView === ViewState.PROJECTS ? <ProjectsViewAtHome/> : null}
            </Box>
        </Box>
    )
}

export default AgenticHome;
